/**
 * Tiny relative-time formatter — "just now", "5m ago", "3h ago",
 * else fall back to a calendar date. Intentionally NOT using
 * Intl.RelativeTimeFormat to keep older Safari happy.
 */
export function timeAgo(iso) {
  if (!iso) return '';
  const sec = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (sec < 60)    return 'just now';
  if (sec < 3600)  return `${Math.floor(sec / 60)}m ago`;
  if (sec < 86400) return `${Math.floor(sec / 3600)}h ago`;
  return new Date(iso).toLocaleDateString();
}
